module.exports = __webpack_public_path__ + "static/DUC_7941-01-square-huong-79f2b94d338f92d2c98d2ba0adad4c64.jpeg";